import { render, staticRenderFns } from "./modify-dialog.vue?vue&type=template&id=05104ca6&scoped=true"
import script from "./modify-dialog.vue?vue&type=script&lang=js"
export * from "./modify-dialog.vue?vue&type=script&lang=js"
import style0 from "./modify-dialog.vue?vue&type=style&index=0&id=05104ca6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05104ca6",
  null
  
)

export default component.exports